import React from 'react'
import { Row, Col, Button } from 'reactstrap'
import { localized } from '@/decorators/localized'
import { FileAttachments, defaultChangeHandler } from '@/components/fileAttachments'
import LoadingIndicator from '@/components/LoadingIndicator'

@localized()
class ReportTemplatesFileAttachments extends React.Component {
  state = {
    attachments: []
  }
  onAttachmentChange = (e) => {
    const attachments = defaultChangeHandler(e, this.state.attachments || [])
    if (attachments !== this.state.attachments) {
      this.setState({ attachments: attachments })
    }
  }
  canAddAttachments () {
    return this.state.attachments.length > 0
  }
  addAttachments () {
    const input = {
      entityId: this.props.parentId,
      fileIds: this.state.attachments.map(x => x.id)
    }
    this.props.addAttachments(input)
  }
  renderAttachments (parentId) {
    return (
      <FileAttachments
        readonly={this.props.disabled}
        accept='.xml,.json'
        attachments={this.state.attachments}
        onChange={this.onAttachmentChange} />
    )
  }
  render () {
    if (this.props.adding === true) { return <LoadingIndicator /> }
    const { localize, parentId, disabled } = this.props
    return (
      <React.Fragment>
        <Row>
          <Col sm='12'>
            {this.renderAttachments(parentId)}
            <div className='text-right mt-3'>
              {!disabled && <Button disabled={!this.canAddAttachments()} onClick={() => this.addAttachments()}>{localize('Common.SaveAttachments')}</Button>}
            </div>
          </Col>
        </Row>
      </React.Fragment>
    )
  }
}

export default ReportTemplatesFileAttachments



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/report-templates/attachments.js